export class Dealer {
    DealerGuid: any;
    DealerCode: number;
    DealerName: string;
    DataType: string;
    Street: string;
    City: string;
    State: string;
    DMS: string;
    SystemContact: any;
    PhoneNumber: any;
    Status: any;
    TimeZone: any;
    Zip: any;
    SalesThreshold: any;
    ServiceThreshold: any;
    DMSAccount: any;
    StatusId: any;
    CreatedBy: any;
    Id: any;
    IsBulkHistory:any;
}
export class NonCDKDealer {
    ParentDealerId: any;
    NaturalKey: number;
    DealerName: string;
    Country: string;
    Street: string;
    City: string;
    State: string;
    SrcDealerCode: string;
    DealerSource: any;
    PhoneNumber: any;
    Status: any;
    TimeZone: any;
    Zip: any;
    FileProcessedDt: any;
    LastRODate: any;
    LastSaleDate: any;
    LastSaleFileDate: any;
    LastROFileDate: any;
    SourceType: any;
}
export class DealerMappingModels {
    DealerID: any;
    DPSDataID: any;
    OCDataID: any;
    PeakDataID: any;
    C1DataID: any;
    DPSApis: any
    OCApis: any;
    PeakApis: any;
    C1Apis: any;
    AutoloopApis: any;
    AutoloopDataID:any;
    CreatedBy: any;
}
export class DealerSourceMapping {
    NaturalKey: any;
    ParentDealerId: number;
    DealerMappingId:number;
    DealerName: string;
    SrcDealerCode: string;
    DealerSource: string;
    FileProcessedDt: string;
    LastRODate: string;
    LastSaleDate: any;
    LastSaleFileDate: any;
    LastROFileDate: any;
    SourceType: any;
    SourceOfDealer: any;
    CreatedBy: any;
    stype:any;
    SrcCode:any;
    RedFlag:boolean;
    YellowFlag:boolean;
    NcoaFlag:boolean;
    VinDecodingFlag:boolean;
    FleetIdentificationFlag:boolean;
    VinValidationFlag:boolean;
    DncFlag:boolean;
    ReturnMailerFlag:boolean;
    ActiveInactiveCustomerFlag:boolean;
    DistanceMilesFlag:boolean;
    NextServiceDueFlag:boolean;
    AdmCalculationsFlag:boolean;
    CcpaFlag:boolean;
}
export class ReturnMailer {
    DealerCode: string;
    FirstName: string;
    LastName: string;
    Address1: string;
    Address2: string;
    FullName:string;
    CustomerGuid:string;
    City: string;
    State: string;
    ZipCode: any;
    ZipCode4: any;
    Vin: any;
    CustomerId:any;
    CreatedBy: any;
    OrgId: any;
    IsLexus:boolean;
}
export class Subscriber {
    ClientId: any;
    SubscriptionTypeId: any;
    ScheduleOptions: any;
    DataSourceId: any;
    SubscriptionName: string;
    ParentDealerId: any[]=[];
    FileTypeId: any;
    CreatedBy: any;
    UpdatedBy: any;
    FileTypes: any;
    ClientName: any;
    SubscriptionTypeName: any;
    ClientSubscriptionId: any;
    SourceName: any;
    CustomDate: any;
    DateRange: any;
    ScheduleType: any;
}

export class ClientSubscription {
    ParentDealerId: any;
    ClientSubscriptionIds: any[]=[];
   
}

export class SelectOption {
    label: string;
    value: any;
}
export class UploadList {
    DealerName:any;
    NaturalKey: any;
    OemName: string;
    FileName: any;
    JsonValue: any;
    FileTypeId: any;
    SourceId: any
}
export class DownloadHeaders {
     OEMCode :any
     NaturalKey :any
     DealerName :any
     FileTypeName :any
     ScheduleType :any
     FileCount :any
     FilePostDate :any
     FileName :any
     MinRODate :any
     MaxRODate :any
    ErrorCode:any;
}